import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { Tooltip, Form } from "antd"
import { Card } from "ui/Card"
import { Icon } from "ui/Icon"
import { Text } from "ui/Typography"
import { TimezoneSelect } from "./TimezoneSelect"
import { DaySelector } from "./DaySelector"
import { TimeBlockForm } from "./TimeBlockForm"

export const DaysAndHours = ({ form }) => {
  const [t] = useTranslation()
  const [markedDays, setMarkedDays] = useState([])

  const [selectedTimezone, setSelectedTimezone] = useState(null)

  const handleTimezoneChange = (value) => {
    setSelectedTimezone(value)
    form.setFieldsValue({ time_zone: value })
  }

  const handleMarkedDays = (day) => {
    const newValue = [...markedDays]
    if (newValue.includes(day)) {
      setMarkedDays(newValue.filter((d) => d !== day))
    } else {
      setMarkedDays([...newValue, day])
    }
  }

  return (
    <Card
      title={
        <div className="align-center">
          {t("experiences.scheduling.sections.days_and_hours.title")}
          <Tooltip title={t("experiences.scheduling.sections.days_and_hours.tooltip")} placement="bottom">
            <Icon className="ml-s" type="feather" name="AlertCircle" width={20} height={20} />
          </Tooltip>
        </div>
      }
      className="mb-3xl"
    >
      <Form.Item name="time_zone" label={t("experiences.scheduling.labels.timezone")} rules={[{ required: true }]}>
        <TimezoneSelect className="mb-l" onChange={handleTimezoneChange} value={selectedTimezone} />
      </Form.Item>
      <Text className="block mb-s" type="subtitle" fw={500}>
        {t("experiences.scheduling.labels.day_and_time")}
      </Text>
      <Form.Item name="available_days" className="mb-xxl">
        <DaySelector form={form} markedDays={markedDays} handleMarkedDays={handleMarkedDays} />
      </Form.Item>
      {markedDays.length > 0 && <TimeBlockForm form={form} />}
    </Card>
  )
}
